define(function (require) {

    window.lpTag = window.lpTag || {};

    var App = window.App || {};

    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var ViewController = require('web-agent-framework/ViewController');
    var EngagementOrbViewController = require('web-agent-viewControllers/EngagementOrbViewController');

    var EngagementOrbsAreaViewController = ViewController.extend({
        ControllerName: "EngagementOrbsAreaViewController",
        ANIMATION_CLASS: "animate",
        ENGAGEMENT_ORB_SIZE_NAMES: ["large", "medium", "small"],
        ENGAGEMENT_ORB_SIZE_VALUES: [100, 58, 30],
        ENGAGEMENT_ORB_DEFAULT_PADDING: 10,
        EXTRA_ORBS_FOR_CALCULATIONS: 1,

        LPViewMap: {
            engagementOrbsArea: ".lpview_engagement_orbs_area_size",
            engagementOrb: ".lpview_engagement_orb"
        },

        initialize: function () {
            this.engagementOrbs = {};
            this.acceptedVisitors = {};
            this.currentSizeIndex = 0;
            this.numberOfOrbs = 0;
            this.engagementOrbsArea = this.getFirstElement(this.LPViewMap.engagementOrbsArea);
        },

        events: function () {
            this.bindModel({modelPath : "agent.status", callback : this.statusChanged});
            this.bindModel({modelPath : "participants.myEngagements", callback : this.handleCreateNewEngagementOrb});
            this.bindModel({modelPath : "participants.simulatedEngagements", callback : this.handleCreateNewEngagementOrb});
            var channel = webAgentStatics.COMMUNICATION_CHANNELS.QUEUE_ORB;
            lpTag.WebAgent.channel.bind(channel.name, channel.events.acceptSuccess, this.handleNewAcceptedEngagement.bind(this));
            this.bindViewEvent({selector : window, DOMEvent : "resize", callback : this.windowWasResized});
            // These events mark that the agent was loaded (F5) - treat like window resize
            this.bindModel({modelPath : "agent.init", callback : this.windowWasResized});
            this.bindModel({modelPath : "agent.inResume", callback : this.windowWasResized});
        },

        render: function () {

        }
    });

    EngagementOrbsAreaViewController.prototype.changeOrbsSize = function (newIndex) {
        if (typeof this.currentSizeIndex !== 'undefined' && this.currentSizeIndex < this.ENGAGEMENT_ORB_SIZE_NAMES.length && this.currentSizeIndex >= 0 &&
            typeof newIndex !== 'undefined' && newIndex !== this.currentSizeIndex) {
            this.removeClass(this.engagementOrbsArea, this.ENGAGEMENT_ORB_SIZE_NAMES[this.currentSizeIndex]);
            if (newIndex < this.ENGAGEMENT_ORB_SIZE_NAMES.length && newIndex >= 0) {
                this.currentSizeIndex = newIndex;
            } else if (newIndex < 0) {
                this.currentSizeIndex = 0;
            } else {
                this.currentSizeIndex = this.ENGAGEMENT_ORB_SIZE_NAMES.length - 1;
            }
            this.addClass(this.engagementOrbsArea, this.ENGAGEMENT_ORB_SIZE_NAMES[this.currentSizeIndex]);
        }
    };

    EngagementOrbsAreaViewController.prototype.getAreaWidth = function () {
        return this.engagementOrbsArea.offsetWidth;
    };

    EngagementOrbsAreaViewController.prototype.getOrbSize = function (sizeIndex) {
        var value = this.ENGAGEMENT_ORB_SIZE_VALUES[0];
        if (typeof sizeIndex !== 'undefined' && sizeIndex >= 0 && sizeIndex < this.ENGAGEMENT_ORB_SIZE_VALUES.length) {
            value = this.ENGAGEMENT_ORB_SIZE_VALUES[sizeIndex];
        }
        return value;
    };

    EngagementOrbsAreaViewController.prototype.getOrbPadding = function () {
        return this.ENGAGEMENT_ORB_DEFAULT_PADDING;
    };

    EngagementOrbsAreaViewController.prototype.isItPossibleToIncreaseOrbsSize = function (sizeIndex) {
        return sizeIndex > 0;
    };

    EngagementOrbsAreaViewController.prototype.isItPossibleToDecreaseOrbsSize = function (sizeIndex) {
        return sizeIndex < this.ENGAGEMENT_ORB_SIZE_NAMES.length - 1;
    };

    EngagementOrbsAreaViewController.prototype.calculateTotalOrbsWidth = function (sizeIndex, extraOrbs) {
        extraOrbs = extraOrbs || 0;
        return (this.numberOfOrbs + extraOrbs) * (this.getOrbSize(sizeIndex) + this.getOrbPadding());
    };

    EngagementOrbsAreaViewController.prototype.shouldIncreaseOrbsSize = function (sizeIndex) {
        return this.isItPossibleToIncreaseOrbsSize(sizeIndex) &&
            this.calculateTotalOrbsWidth(sizeIndex - 1, this.EXTRA_ORBS_FOR_CALCULATIONS) < this.getAreaWidth();
    };

    EngagementOrbsAreaViewController.prototype.shouldDecreaseOrbsSize = function (sizeIndex) {
        return this.isItPossibleToDecreaseOrbsSize(sizeIndex) &&
            this.calculateTotalOrbsWidth(sizeIndex, this.EXTRA_ORBS_FOR_CALCULATIONS) > this.getAreaWidth();
    };

    EngagementOrbsAreaViewController.prototype.windowWasResized = function (data) {
        if (typeof data.newValue != 'undefined' && data.newValue !== true) {
            return;
        }
        this.removeClass(this.engagementOrbsArea, this.ANIMATION_CLASS);
        this.changeOrbsSizeIfNeeded();
    };

    EngagementOrbsAreaViewController.prototype.updateNumberOfOrbs = function () {
        var numberOfOrbs = 0;
        for (var visitorId in this.engagementOrbs) {
            if (this.engagementOrbs.hasOwnProperty(visitorId) && this.engagementOrbs[visitorId].visible) {
                numberOfOrbs++;
            }
        }
        this.numberOfOrbs = numberOfOrbs;
    };

    EngagementOrbsAreaViewController.prototype.changeOrbsSizeIfNeeded = function () {
        this.updateNumberOfOrbs();
        if (typeof this.currentSizeIndex !== 'undefined') {
            // The area width can be "" when the fragment is outside the DOM
            var shouldKeepChecking = this.numberOfOrbs > 0 && this.getAreaWidth();
            var tempSizeIndex = this.currentSizeIndex;
            while (shouldKeepChecking) {
                shouldKeepChecking = false;
                if (this.shouldDecreaseOrbsSize(tempSizeIndex)) {
                    tempSizeIndex++;
                    shouldKeepChecking = true;
                } else if (this.shouldIncreaseOrbsSize(tempSizeIndex)) {
                    tempSizeIndex--;
                    shouldKeepChecking = true;
                }
            }
            if (tempSizeIndex !== this.currentSizeIndex) {
                this.changeOrbsSize(tempSizeIndex);
            }
        }
    };

    EngagementOrbsAreaViewController.prototype.statusChanged = function (data) {
        if (typeof data.newValue != 'undefined' && data.newValue !== 'loggedIn') {
            this.engagementOrbs = {};
            this.viewControllers = [];
            this.dispose();
        }
    };

    EngagementOrbsAreaViewController.prototype.handleCreateNewEngagementOrb = function (data) {
        for (var visitorId in data.newValue) {
            if (data.newValue.hasOwnProperty(visitorId)) {
                this.handleCreateSingleOrb(visitorId, data.newValue[visitorId]);
            }
        }
    };

    EngagementOrbsAreaViewController.prototype.handleCreateSingleOrb = function (visitorId, visitorData) {
        var acceptData = this.acceptedVisitors[visitorId];
        this.engagementOrbs[visitorId] = new EngagementOrbViewController({
            modelController: this.modelController,
            visitorId: visitorId,
            visitorSerialNumber: visitorData.participantInfo.visitorSerialNumber,
            className: "lpview_engagement_orb ",
            templateFile: 'LP_engagement_orb.html',
            isAutoAccepted: !!acceptData && !!acceptData.isAutoAccepted,
            hidden: true
        });
        if (acceptData) {
            acceptData = null;
            this.acceptedVisitors[visitorId] = null;
            delete this.acceptedVisitors[visitorId];
        }
        this.addViewController({viewController : this.engagementOrbs[visitorId], target: this.LPViewMap.engagementOrbsArea});//, beforeView: this.getFirstElement(this.LPViewMap.engagementOrb), fadeIn:true});
        this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_DISPOSED, callback : this.visitorDisposed});
        this.viewEventsHandler.bindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_VISIBILITY_CHANGED, callback : this.orbVisibilityChanged});
    };

    EngagementOrbsAreaViewController.prototype.handleNewAcceptedEngagement = function (data) {
        if (data && data.visitorId && !this.engagementOrbs[data.visitorId]) {
            this.acceptedVisitors[data.visitorId] = data;
        }
    };

    EngagementOrbsAreaViewController.prototype.visitorDisposed = function (data) {
        if (data.newValue) {
            var visitorId = data.newValue.eventData.visitorId;
            this.engagementOrbs[visitorId].lpHide();
            // Do not dispose, the widget should dispose itself.
            this.engagementOrbs[visitorId] = undefined;
            delete this.engagementOrbs[visitorId];
            this.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_DISPOSED, callback : this.visitorDisposed});
            this.viewEventsHandler.unbindEvent({appName : visitorId, UIEvent : this.eventType.VISITOR_VISIBILITY_CHANGED, callback : this.orbVisibilityChanged});
            this.changeOrbsSizeIfNeeded();
        }
    };

    EngagementOrbsAreaViewController.prototype.orbVisibilityChanged = function (data) {
        if (data && data.newValue) {
            this.removeClass(this.engagementOrbsArea, this.ANIMATION_CLASS);
            this.addClass(this.engagementOrbsArea, this.ANIMATION_CLASS);
            this.changeOrbsSizeIfNeeded();
        }
    };

    return EngagementOrbsAreaViewController;

});
